import React from 'react';
import { motion } from 'motion/react';
import { AlertCircle, CheckCircle } from 'lucide-react';
import { alertVariants } from './authMotion';

export default function AuthAlert({ type = 'error', message }) {
  if (!message) return null;

  const isError = type === 'error';
  const Icon = isError ? AlertCircle : CheckCircle;

  return (
    <motion.div
      variants={alertVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className={`flex items-start gap-3 rounded-xl border px-4 py-3 text-sm ${
        isError
          ? 'border-red-200 bg-red-50 text-red-700'
          : 'border-emerald-200 bg-emerald-50 text-emerald-800'
      }`}
      role={isError ? 'alert' : 'status'}
    >
      <Icon className="mt-0.5 h-5 w-5 shrink-0" strokeWidth={1.75} aria-hidden="true" />
      <span>{message}</span>
    </motion.div>
  );
}
